import { InjectionToken } from '@angular/core';

export interface BnApiConfig {
  apiUrl: string;
}

export const BN_API_CONFIG = new InjectionToken<BnApiConfig>('BN_API_CONFIG');
